import { Dispatch } from "redux";
import { FormattedWorkflowConfiguration } from "@idw-types/data/workflow-configuration/workflow-configuration";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { setWorkflowConfigurations, setWorkflowConfigurationsLoading } from "@redux/actions/workflows-actions";
import { formatWorkflowConfigurations } from "@formatters/workflows/workflow-configuration-formatter";
import { getWorkflowConfigurationsRequest } from "@requests/service-configuration";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getWorkflowConfigurationsReduxRequest = (dispatch: Dispatch) => async (
    companies: Array<AxnCompany>,
    relyingParties: Array<AxnRelyingParty>
): Promise<Array<FormattedWorkflowConfiguration>> => {
    dispatch(setWorkflowConfigurationsLoading(true));
    const { data, error } = await getWorkflowConfigurationsRequest();
    if (data) {
        const formattedWorkflowConfigurations = formatWorkflowConfigurations(data, companies, relyingParties);
        dispatch(setWorkflowConfigurations(formattedWorkflowConfigurations));
        return formattedWorkflowConfigurations;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getWorkflowConfigurations.error.title,
                resources.requests.getWorkflowConfigurations.error.message
            );
        }
        dispatch(setWorkflowConfigurationsLoading(false));
    }

    return null;
};